import { getCdnClient } from "../components/shared/services/api/cdnClient";
import { CDNGridData, GridData } from "../components/shared/types/grid";
import {
  Restaurant,
  RestaurantMenu,
  RestCreDB,
} from "../components/shared/types/restaurant.types";
import { getTimestamp } from "../components/shared/utils/formatters";
import { Coordinates } from "../types/user";
import { fetchGridData, getProximityGridIds } from "./grid.service";

interface RestaurantsData {
  restaurants: {
    [key: string]: Partial<Restaurant>;
  };
}

//NOTE before removing check with s3 file if all the required data exist as below is the working code.
// let restByIdDummy: RestCreDB = {
//   lastUpdatedAt: "2025-01-24T08:12:20.590Z",
//   fssaiUrl:
//     "http://192.168.29.175:4569/restaurants/1d97dd91-aa40-4cfa-b968-420ec61d2dbc/fssai/0e796a61-4935-482b-b9c6-f3eedf0af8f0.png",
//   hasGst: false,
//   avgCostForTwo: 200,
//   createdAt: "2025-01-17T16:16:24.902Z",
//   fssaiNum: "Nxjzjzjjzzuzuz",
//   grid_id: "19.2_72.85",
//   deliveryDetails: { maxDistance: 5, estimatedTime: 10 },
//   timings: {
//     monday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     tuesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     wednesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     thursday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     friday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     saturday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//     sunday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
//   },
//   packCharges: [{ max: 1000000, min: 0, charge: 0 }],
//   id: "1d97dd91-aa40-4cfa-b968-420ec61d2dbc",
//   profileImg: [
//     "http://192.168.29.175:4569/restaurants/1d97dd91-aa40-4cfa-b968-420ec61d2dbc/profile/7affb4a8-d5b4-426c-82e4-436ebc2f1ae1.png",
//   ],
//   menuUrls: [],
//   image: "",
//   fssaiExp: "25/01/2025",
//   cat: [],
//   menuItems: [
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "veg",
//       description:
//         "Made with so and so.\n1. This is what it is\n2. This is it.\n3. This is it",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Pav bhaji",
//       id: "item-17376967160440",
//       category: "",
//       totalReview: 0,
//     },
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "veg",
//       description:
//         "Made with so and so.\n1. This is what it is\n2. This is it.\n3. This is it",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Pav bhaji",
//       id: "item-17376967160441",
//       category: "",
//       totalReview: 0,
//     },
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "veg",
//       description:
//         "Made with so and so.\n1. This is what it is\n2. This is it.\n3. This is it",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Pav bhaji",
//       id: "item-17376967160442",
//       category: "",
//       totalReview: 0,
//     },
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "veg",
//       description:
//         "Made with so and so.\n1. This is what it is\n2. This is it.\n3. This is it",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Pav bhaji",
//       id: "item-17376967160443",
//       category: "",
//       totalReview: 0,
//     },
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "veg",
//       description:
//         "Made with so and so.\n1. This is what it is\n2. This is it.\n3. This is it",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Pav bhaji",
//       id: "item-17376967160444",
//       category: "",
//       totalReview: 0,
//     },
//     {
//       serviceType: "both",
//       subCategory: "",
//       avgReview: 0,
//       foodType: "egg",
//       description:
//         "1. This\n2. That\n3. This is it.\n4. That is that\n5. This is this is",
//       tax: 5,
//       price: 100,
//       isEnabled: true,
//       imageUrl: "",
//       name: "Missal",
//       id: "item-17376981363325",
//       category: "",
//       totalReview: 0,
//     },
//   ],
//   approvedAt: "",
//   neighbor_grids: [],
//   cuisines: ["South Indian", "Thai", "Japanese"],
//   gstNumber: null,
//   createdBy: "655d43d1-7a17-4754-882e-f8e3a4122238",
//   primaryContact: "+919686767679",
//   name: "JISHAN's Food",
//   location: {
//     coordinates: { latitude: 19.2142353, longitude: 72.8310753 },
//     address: { locality: "Kandivali East", city: "Mumbai" },
//   },
//   licenseAccepted: false,
//   status: "submitted",
//   avgReview: "0",
//   totalReview: "0",
//   updatedAt: new Date().toISOString(),
//   lastUpdated: new Date().toISOString(),
// };

//NOTE before removing check with s3 file if all the required data exist as below is the working code.
let dummyData: RestaurantsData = {
  restaurants: {
    "1d97dd91-aa40-4cfa-b968-420ec61d2dbc": {
      name: "Restaurant Name",
      deliveryDetails: { maxDistance: 4, estimatedTime: 30 },
      timings: {
        monday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        tuesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        wednesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        thursday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        friday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        saturday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        sunday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
      },
      location: {
        coordinates: { latitude: 19.2142353, longitude: 72.8310753 },
        address: { locality: "Kandivali East", city: "Mumbai" },
      },
      id: "1d97dd91-aa40-4cfa-b968-420ec61d2dbc",
      profileImg: [],
      avgCostForTwo: 200,
      cuisines: ["South Indian", "Thai", "Japanese"],
      status: "submitted",
      avgReview: "4.6",
      updatedAt: "2025-01-21T13:44:23.214Z",
      lastUpdated: "2025-01-24T05:56:26.082Z",
    },
    "1d97dd91-aa40-4cfa-b968-420ec61d2dbc2": {
      name: "Restaurant Name",
      deliveryDetails: { maxDistance: 4, estimatedTime: 30 },
      timings: {
        monday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        tuesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        wednesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        thursday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        friday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        saturday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        sunday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
      },
      location: {
        coordinates: { latitude: 19.2142353, longitude: 72.8310753 },
        address: { locality: "Kandivali East", city: "Mumbai" },
      },
      id: "1d97dd91-aa40-4cfa-b968-420ec61d2dbc2",
      profileImg: [],
      avgCostForTwo: 200,
      cuisines: ["South Indian", "Thai", "Japanese"],
      status: "submitted",
      updatedAt: "2025-01-21T13:44:23.214Z",
      lastUpdated: "2025-01-24T05:56:26.082Z",
      avgReview: "4.6",
    },
    "1d97dd91-aa40-4cfa-b968-420ec61d2dbc3": {
      name: "Restaurant Name",
      deliveryDetails: { maxDistance: 4, estimatedTime: 30 },
      timings: {
        monday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        tuesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        wednesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        thursday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        friday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        saturday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        sunday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
      },
      location: {
        coordinates: { latitude: 19.2142353, longitude: 72.8310753 },
        address: { locality: "Kandivali East", city: "Mumbai" },
      },
      id: "1d97dd91-aa40-4cfa-b968-420ec61d2dbc3",
      profileImg: [],
      avgCostForTwo: 200,
      cuisines: ["South Indian", "Thai", "Japanese"],
      status: "submitted",
      updatedAt: "2025-01-21T13:44:23.214Z",
      lastUpdated: "2025-01-24T05:56:26.082Z",
      avgReview: "4.6",
    },
    "1d97dd91-aa40-4cfa-b968-420ec61d2dbc4": {
      name: "Restaurant Name",
      deliveryDetails: { maxDistance: 4, estimatedTime: 30 },
      timings: {
        monday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        tuesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        wednesday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        thursday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        friday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        saturday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
        sunday: [{ isOpen: true, openTime: "12", closeTime: "19" }],
      },
      location: {
        coordinates: { latitude: 19.2142353, longitude: 72.8310753 },
        address: { locality: "Kandivali East", city: "Mumbai" },
      },
      id: "1d97dd91-aa40-4cfa-b968-420ec61d2dbc4",
      profileImg: [],
      avgCostForTwo: 200,
      cuisines: ["South Indian", "Thai", "Japanese"],
      status: "submitted",
      updatedAt: "2025-01-21T13:44:23.214Z",
      lastUpdated: "2025-01-24T05:56:26.082Z",
      avgReview: "4.6",
    },
  },
};

class RestaurantService {
  // getRestaurants(loc: Coordinates): Partial<Restaurant>[] {
  //   return Object.values(dummyData.restaurants);
  // }

  async getRestaurants(location: Coordinates): Promise<GridData[]> {
    console.log("[getRestaurants] Starting restaurant fetch", {
      latitude: location.latitude,
      longitude: location.longitude,
    });

    const startTime = performance.now();
    const gridIds = getProximityGridIds(location);
    const calculationTime = performance.now() - startTime;
    console.log(
      `[getRestaurants] Grid calculation completed in ${calculationTime}ms`,
      {
        numberOfGrids: gridIds,
      }
    );

    // Fetch data for each grid, prioritizing nearest neighbors
    const restaurantData: GridData[] = [];

    for (const gridId of gridIds) {
      try {
        const gridData: CDNGridData | null = await fetchGridData(gridId);
        console.log("gridData: ", gridData);
        // If gridData is null (not found case), continue to next grid
        if (!gridData) {
          continue;
        }

        for (const key in gridData.restaurants) {
          if (gridData.restaurants.hasOwnProperty(key)) {
            restaurantData.push(gridData.restaurants[key]);
          }
        }
      } catch (error) {
        console.error(
          `[getRestaurants] Error processing grid ${gridId}:`,
          error
        );
      }
    }

    console.log("[getRestaurants] Fetch completed", {
      totalRestaurants: restaurantData.length,
    });

    return restaurantData;
  }

  //TODO: add support to get the cached rest for same restId and lastUpAt
  async getRestById(
    restId: string,
    lastUpAt?: string
  ): Promise<RestaurantMenu> {
    try {
      console.log("in getRestById, restId ", restId, ", lastUpAt: ", lastUpAt);
      const bucketBaseUrl = `/rest/${restId}`;
      let resolvedLastUpAt = lastUpAt;

      // Step 1: Check if lastUpAt is undefined or empty
      if (!resolvedLastUpAt || resolvedLastUpAt.length === 0) {
        // Fetch the latest.json file to get the latest timestamp
        const latestFileUrl = `${bucketBaseUrl}/latest.json`;
        const latestResponse = await getCdnClient(latestFileUrl, {
          useCache: false,
        });

        console.log("latestResponse: ", latestResponse);

        if (!latestResponse) {
          throw new Error("Failed to fetch latest.json");
        }

        // Extract the latest timestamp from the response
        resolvedLastUpAt = latestResponse.latest.replace(".json", ""); // Remove ".json" extension
      } else {
        resolvedLastUpAt = getTimestamp(resolvedLastUpAt).toString();
      }

      // Step 2: Construct the file URL using the resolved timestamp
      const fileUrl = `${bucketBaseUrl}/${resolvedLastUpAt}.json`;
      const restaurantData: RestCreDB = await getCdnClient(fileUrl, {
        useCache: true,
      });

      // Step 3: Parse the restaurant data and return the structured object
      const { menuItems, cat, ...restDetails } = restaurantData;

      return {
        restaurant: restDetails,
        menuItems,
        cat,
      };
    } catch (error) {
      console.error("Error fetching restaurant data", {
        restId,
        lastUpAt,
        error,
      });
      throw error; // Re-throw the error for the caller to handle
    }
  }
}

export const restaurantService = new RestaurantService();
